import "./bootstrap";

// Import modules...
import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import { AppName } from "@/config/page-settings";

import.meta.glob(["../images/**", "../favicon/**"], { eager: true });

const AppTitle = import.meta.env.VITE_APP_NAME || AppName;

createInertiaApp({
    title: (title) => `${title} - ${AppTitle}`,
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: "#4b0900",
        delay: 40,
    },
});
